import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BackendHttpClient } from "@api/http";
import { Observable } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class RFQSService {
  constructor(private http: BackendHttpClient) {}

  // GET RFQS and Bids
  getRFQS(params = {}): Observable<any> {
    return this.http.get<any>("offers/rfq", {
      params: params,
    });
  }

  // GET RFQ and Bids by id
  getRFQById(id): Observable<any> {
    return this.http.get<any>(`offers/rfq/${id}`);
  }

  // GET RFQ history
  getRFQHistory(id: number, params = {}): Observable<any> {
    return this.http.get<any>(`offers/rfq/${id}/activity`, {
      params: params,
    });
  }

  // GET RFQ and Bids by id
  getProvidersInvitationList(params = {}): Observable<any> {
    const keys = Object.keys(params);
    let url = "";
    keys.forEach((key) => {
      if (key === "service_category_id") {
        params[key].forEach((e, i) => {
          url = url + `service_category_id[${i}]=${e}&`;
        });
      } else {
        url = url + `${key}=${params[key]}&`;
      }
    });
    url = url.slice(0, -1);

    return this.http.get<any>(
      //  '/rfqs/list-of-providers',
      `rfqs/list-of-providers?${url}`,
      params
    );
  }

  // GET RFQ and Bids by id
  getAllProvidersInvitationList(params = {}): Observable<any> {
    const keys = Object.keys(params);
    let url = "";
    keys.forEach((key) => {
      if (key === "service_category_id") {
        params[key].forEach((e, i) => {
          url = url + `service_category_id[${i}]=${e}&`;
        });
      } else {
        url = url + `${key}=${params[key]}&`;
      }
    });
    url = url.slice(0, -1);

    return this.http.get<any>(
      `offers/rfqs/list-of-all-providers?${url}`,
      params
    );
  }

  // GET service offers for creating new RFQ
  getRFQServiceOffers(params = {}): Observable<any> {
    let url = "?";
    const keys = Object.keys(params);
    keys.forEach((key) => {
      if (key === "category_id") {
        params[key].forEach((e, i) => {
          url = url + `category_id[${i}]=${e}&`;
        });
      } else {
        url = url + `${key}=${params[key]}&`;
      }
    });
    url = url.slice(0, -1);

    return this.http.get<any>(`offers/rfqs/list-of-offers${url}`);
  }

  createRFQAndBid(rfq): Observable<any> {
    return this.http.post<any>("offers/rfqs/create", rfq, httpOptions);
  }

  saveDraftRFQAndBid(rfq): Observable<any> {
    return this.http.post<any>("offers/rfqs/create/draft", rfq, httpOptions);
  }

  getStatusTransitions(): Observable<any> {
    return this.http.get("offers/rfq/transitions");
  }

  // Update RFQ/Bid status
  updateStatusBulk(status, client_id, rfq_id, reason = ""): Observable<any> {
    let body: any = { status: status, client_id: client_id };
    if (reason) {
      body = {
        status: status,
        client_id: client_id,
        declined_reason: reason,
      };
    }
    return this.http.post<any>(
      `rfqs/${rfq_id}/change-status`,
      body,
      httpOptions
    );
  }

  // Update RFQ/Bid details
  updateRFQDetails(params): Observable<any> {
    return this.http.put<any>("offers/rfqs/update", params, httpOptions);
  }

  // Update RFQ/Bid details
  updateDraftRFQDetails(params): Observable<any> {
    return this.http.put<any>("offers/rfqs/update/draft", params, httpOptions);
  }

  // add RFQ offer
  addOfferQuotation(offer, rfq_id): Observable<any> {
    return this.http.post<any>(
      `offers/rfqs/${rfq_id}/add-offer`,
      offer,
      httpOptions
    );
  }

  // get offers by provider for RFQ
  getOffersByProvider(params): Observable<any> {
    return this.http.get("rfqs/list-of-offers-by-provider", { params: params });
  }

  // Accept/ Decline RFQ quotation offers
  statusOfferQuotation(params, rfq_quotation_id): Observable<any> {
    return this.http.post<any>(
      `offers/rfqs/${rfq_quotation_id}/change-status-offer-quotation`,
      params,
      httpOptions
    );
  }

  // Get RFQ quotation offers
  getAcceptedOffers(params): Observable<any> {
    return this.http.post<any>("offers/finalize-rfqs", params, httpOptions);
  }

  // Add to cart
  addRFQtoCart(params): Observable<any> {
    return this.http.post<any>("rfqs/add-to-cart", params, httpOptions);
  }

  extendAvailability(period, id) {
    return this.http.put<any>(
      `rfqs/update-period/${id}`,
      { period: period },
      httpOptions
    );
  }

  declineRFQInvitation(params, id): Observable<any> {
    return this.http.post<any>(
      `rfqs/${id}/change-status-provider-invitation`,
      params,
      httpOptions
    );
  }
}
